export default "__VITE_ASSET__BFE2bui6__"